import React, { Component } from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import { SimpleFlexbox, ModalContainer } from 'ctm-components';
import { get, getRulesFromState, haveRulesChanged } from 'ctm-util-functions';

class _ResultsFilterModal extends Component {

    constructor(props) {
        super(props);
        this.containerVisualProps = { margin: 'right', display: 'flex', itemsCenter: 'xs' };
    }

    /**
     * Don't re-render unless rules have changed
     * @param {Object} nextProps - The incoming set of props
     * @param {Object} nextState - The incoming component state
     * @returns {Boolean} - True if the component should re-render, false otherwise
     */
    shouldComponentUpdate = (nextProps, nextState) => {
        return haveRulesChanged(nextProps, this.props);
    };

    /**
     * Render the ResultsFilterModal if it is visible, otherwise return null
     * @returns {Node|Null} - The ResultsFilterModal if it is visible
     */
    render = () => {
        if (!get(this.props, 'rules.visibility.result', false)) {
            return null;
        }

        const { modalProps, children } = this.props;

        return (
            <SimpleFlexbox display="flex" column="xs">
                <ModalContainer {...modalProps}>
                    {children}
                </ModalContainer>
            </SimpleFlexbox>
        );
    };

}

_ResultsFilterModal.propTypes = {
    rules: PropTypes.object,
    stateProps: PropTypes.object,
    modalProps: PropTypes.object,
    children: PropTypes.array
};

/**
 * Map the rules to the props
 * @param {Object} state - The application state
 * @param {Object} props - The component props
 * @returns {Object} - The resolved rules object
 */
const mapStateToProps = (state, props) => {
    return props.rules ? { rules: getRulesFromState(state, props) } : props;
};

export const ResultsFilterModal = connect(mapStateToProps)(_ResultsFilterModal);
export { _ResultsFilterModal };
